
export const defaultsBookings = [
    {
        "name": "collect",
        "order": -1,
        "hidden": false
    },
    {
        "name": "BOLNumber",
        "order": 0,
        "hidden": false
    },
    {
        "name": "shipmentMode",
        "order": 1,
        "hidden": false
    },
    {
        "name": "bookDate",
        "order": 2,
        "hidden": false
    },
    {
        "name": "estimatedPickupDate",
        "order": 3,
        "hidden": false
    },
    {
        "name": "estimatedDeliveryDate",
        "order": 4,
        "hidden": false
    },
    {
        "name": "actualPickupDate",
        "order": 5,
        "hidden": true
    },
    {
        "name": "actualDeliveryDate",
        "order": 6,
        "hidden": true
    },
    {
        "name": "shipperName",
        "order": 7,
        "hidden": false
    },
    {
        "name": "shipperDetails",
        "order": 8,
        "hidden": true
    },
    {
        "name": "originCity",
        "order": 9,
        "hidden": true
    },
    {
        "name": "originState",
        "order": 10,
        "hidden": true
    },
    {
        "name": "originZipcode",
        "order": 11,
        "hidden": true
    },
    {
        "name": "shipperReferenceNumber",
        "order": 12,
        "hidden": true
    },
    {
        "name": "consigneeName",
        "order": 13,
        "hidden": false
    },
    {
        "name": "consigneeDetails",
        "order": 14,
        "hidden": true
    },
    {
        "name": "destinationCity",
        "order": 15,
        "hidden": true
    },
    {
        "name": "destinationState",
        "order": 16,
        "hidden": true
    },
    {
        "name": "destinationZipcode",
        "order": 17,
        "hidden": true
    },
    {
        "name": "consigneeReferenceNumber",
        "order": 18,
        "hidden": true
    },
    {
        "name": "pieces",
        "order": 19,
        "hidden": true
    },
    {
        "name": "weight",
        "order": 20,
        "hidden": true
    },
    {
        "name": "class",
        "order": 21,
        "hidden": true
    },
    {
        "name": "carrierName",
        "order": 22,
        "hidden": false
    },
    {
        "name": "carrierServiceLevel",
        "order": 23,
        "hidden": true
    },
    {
        "name": "carrierPRO",
        "order": 24,
        "hidden": false
    },
    {
        "name": "customerQuoteNumber",
        "order": 25,
        "hidden": true
    },
    {
        "name": "totalDue",
        "order": 26,
        "hidden": false
    },
    {
        "name": "billPartyReferenceNumber",
        "order": 27,
        "hidden": true
    },
    {
        "name": "invoiced",
        "order": 28,
        "hidden": true
    },
    {
        "name": "dispatched",
        "order": 29,
        "hidden": true
    },
    {
        "name": "lastStatus",
        "order": 30,
        "hidden": false
    }
  ]